export const Config = {
    API_URL: process.env.REACT_APP_API_URL,
    GAME_SERVICE_API_URL: process.env.REACT_APP_GAME_SERVICE_API_URL,
    MAIN_BODY_BACKGROUND: process.env.REACT_APP_MAIN_BODY_BACKGROUND || "none",
}
